import { createSelector } from 'reselect';

import {
  // Features
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  // Frame
  hasUserSelector,
  // Navigation
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
} from '../../../selectors';

const topInputSelectors = [
  hasUserSelector,
  featuresIsPremiumSelector,
  featuresIsProJobsSelector,
  featuresIsProBusinessSelector,
  navigationHomeSelector,
  navigationMessagesSelector,
  navigationContactsSelector,
  navigationPremiumSelector,
  navigationPremiumUpsellSelector,
  navigationProJobsSelector,
  navigationProBusinessSelector,
];
const topTransform = (
  hasUser,
  isPremium,
  isProJobs,
  isProBusiness,
  home,
  messages,
  contacts,
  premium,
  premiumUpsell,
  proJobs,
  proBusiness
) => {
  return [
    home,
    contacts,
    messages,
    ...(hasUser
      ? [
          isPremium ? premium : premiumUpsell,
          isProJobs && proJobs,
          isProBusiness && proBusiness,
        ]
      : []),
  ].filter(Boolean);
};
export default createSelector(
  ...topInputSelectors,
  topTransform
);
